import tepService from '@/service/tep-service';
import { api } from '@/service/http';

const getCardITData = async () => {
    return {
        result: true,
        data: {
            name: '',
            kod_abon: null,
            name_strct_podr: '',

            tarif1: null,
            npp1: null,
            name_tarif1: '',
            rate1: null,

            tarif2: null,
            npp2: null,
            name_tarif2: '',
            rate2: null,

            name_tg: null,
            t1: null,
            t2: null,
            t1_sg: null,
            t2_sg: null,
            kod_tgr: null
        }
    }
}

const getCardTV_OtvData = async (params) => {
    const result = await api('tep-grid./tep/card-vid/new-data/get', {kod_vid: params.kod_vid, kod_r: params.kod_r });
    const data = {
        result: true,
        data: {
            path: params.source_path,
            name: null,
            kod_tn: 1,
            tn_name: 'Вода',
            podr_name: null,
            t1_so: null,
            t2_so: null,
            t1_sovk: null,
            t2_sovk: null,
            t1_sw: null,
            t2_sw: null,
            t1_swvk: null,
            t2_swvk: null,
            t1_gwm: null,
            t2_gwm: null,
            t1_gwsr: null,
            t2_gwsr: null,
            tnv_so: null,
            tnv_sw: null,
            kod_sxp_so: null,
            kod_sxp_sw: null,
            kod_sxp_gw: null,
            kod_tso: null,
            kod_tsw: null,
            kod_sxp_so_name: null,
            kod_sxp_sw_name: null,
            kod_sxp_gw_name : null,
            gr_balans: null,
            gr_ekspl: null,
            name_abon: null,
            name_to: null,
        }
    }
    if(result.result) {
        data.data = {...data.data, ...result.data};
        return data;
    } else {
        return result
    }
}

const getCardPVData = async (params) => {
    return {
        result: true,
        data: {
            path: params.source_path,
            name: null,
            kod_tn: 2,
            tn_name: 'Пар',
            harp_name: null,
            kod_harp: null,
            p_p: null,
            p_ot: null,
            p_do: null,
            p_t: null,
            t_ot: null,
            t_do: null,
            ts: null,
            gr_balans: null,
            gr_ekspl: null,
            kod_abon: null,
            name_abon: null,
            kod_to: null,
            name_to: null,
        }
    }
}

const getCardOtvPData = async (params) => {
    return {
        result: true,
        data: {
            name: '',
            path: params.source_path
        }
    }
}

const getCardTC_OdpuData = async (params) => {
    return {
        result: true,
        data: {
            name: '',
            path: params.source_path,
            kod_tn: params.kod_vid < 45 ? 1 : 2,
            tn_name: params.kod_vid < 45 ? 'Вода' : 'Пар',
            nn: '',
            pr_sum_opu: false
        }
    }
}

const getCardAVData = async (params) => {
    const result = await api('tep-grid./tep/card-vid/new-data/get', {kod_vid: params.kod_vid, kod_r: params.kod_r });
    const data = {
        result: true,
        data: {
            name: null,
            path: params.source_path,
            kod_tn: params.kod_vid < 55 ? 1 : 2,
            tn_name: params.kod_vid < 55 ? 'Вода' : 'Пар',
            kod_reg: null, // район
            name_reg: null,
            podr_name: null, // подразделение
            // адрес
            kod_adr1: null,
            name_adr1: null,
            // строительный адрес
            kod_adr2: null,
            name_adr2: null,
            gr_balans: null, // граница баланса
            gr_ekspl: null, // граница эксплуатации
            kod_abon: null, // баланс
            name_abon: null,
            kod_to: null, // тех. обслуживание
            name_to: null,
            ndog: null,
            // коэффициенты использования
            pr_so: false, // Система отопления
            pr_gw: false, // Система горячего водоснабжения
            // схемы подключения нагрузок
            kod_sxp_sop: null,
            kod_sxp_swp: null,
            kod_sxp_stp: null,
            kod_sxp_gwp: null,
            kpd_so: 95,
            kpd_sw: 95,
            kpd_st: 95,
            kpd_gw: 95,
            sxp_so: null,
            sxp_sw: null,
            sxp_st: null,
            sxp_gw: null,
            // ПАР Расчет температуры
            tnv_so: null,
            tnv_sw: null,
            harp_name: null,
            kod_harp: null,
            p_p: null,
            p_ot: null,
            p_do: null,
            p_ti: null,
            ti_ot: null,
            ti_do: null,
            tsi: null,
            p_pa: null,
            pa_ot: null,
            pa_do: null,
            p_ta: null,
            ta_ot: null,
            ta_do: null,
            tsa: null,
            p_tk: 80,
            srvoz: 80,
            srvoz_flag: false,
            gmin: 0,
            gmin_mos: 0,
        }
    }
    if(params.kod_vid === 55) {
        if(result.result) {
            data.data = {...data.data, ...result.data};
            return data;
        } else {
            return result
        }
    }
    else {
        return data;
    }
}

const getCardOpu_UuData = async (params) => {
    return {
        result: true,
        data: {
            path: params.source_path,
            name: null,
            kod_askute: null,
            name_adr: null,
            prib_flag: 'active_prib',
            pr_active: 0,
            pr_active_name: 'Допуск',
            ndog: null,
            kod_dog: null,
            data_komu_uu: null,
            data_okon_uu: null,
            odpu: null,
            mesto_uu: null,
            name_to_uu: null,
            pr_o_uu: 1,
            pr_v_uu: 1,
            pr_g_uu: 1,
            pr_t_uu: 1,
            is_grid_changed: 0,
        }
    }
}

const getCardCtpData = async (params) => {
    return {
        result: true,
        data: {
            kod: null,
            kod_tn: 1,
            tn_name: 'Вода',
            name: '',
            path: params.source_path,
            kod_ctp: null,
            ctp_name: '',
            pr_stream: null
        }
    }
}

const getCardAuprData = async (params) => {
    return {
        result: true,
        data: {
            path: params.source_path,
            name: null,
            is_grid_changed: 0,
        }
    }
}

const gerCardItpData = async (params) => {
    const result = await api('tep-grid./tep/card-vid/new-data/get', {kod_vid: params.kod_vid, kod_r: params.kod_r });
    const data = {
        result: true,
        data: {
            path: params.source_path,
            name: null,
            name_adr: null,
            kod_adr1: null,
            kod_adr3: null,
            t1_so: null,
            t2_so: null,
            t1_sovk: null,
            t2_sovk: null,
            t1_sw: null,
            t2_sw: null,
            t1_swvk: null,
            t2_swvk: null,
            t1_gwm: null,
            t2_gwm: null,
            t1_gwsr: null,
            t2_gwsr: null,
            tnv_so: null,
            tnv_sw: null,
            pr_pgst: 1,
            k_pg: null,
            v_so: 0,
            v_sw: 0,
            kod_sxp_so: null,
            kod_sxp_sw: null,
            kod_sxp_gw: null,
            kod_tso: null,
            kod_tsw: null,
            kod_sxp_so_name: null,
            kod_sxp_sw_name: null,
            kod_sxp_gw_name : null,
            pr_sxpsw: false,
            nal_bak: false,
        }
    }
    if(result.result) {
        data.data = {...data.data, ...result.data};
        return data;
    } else {
        return result
    }
}

const getCardData = async (params) => {
    let result = {};
    if (params.kod_r) {
        params.source_path = await tepService.getNewPath(params.kod_r);
    }
    if (params.kod_vid === 10) {
        result = await getCardITData();
    } else if ([20, 30].includes(params.kod_vid)) {
        result = await getCardTV_OtvData(params);
    } else if (params.kod_vid === 25) {
        result = await getCardPVData(params);
    } else if (params.kod_vid === 35) {
        result = await getCardOtvPData(params);
    } else if ([40, 41, 42, 45, 46].includes(params.kod_vid)) {
        result = await getCardTC_OdpuData(params);
    } else if ([50, 55].includes(params.kod_vid)) {
        result = await getCardAVData(params);
    } else if ([22200000, 22210000, 32200000].includes(params.kod_vid)) {
        result = await getCardOpu_UuData(params);
    } else if (params.kod_vid === 22550000) {
        result = await getCardCtpData(params);
    } else if (params.kod_vid === 32240000) {
        result = await getCardAuprData(params);
    } else if (params.kod_vid === 22510000) {
        result = await gerCardItpData(params);
    }
    return result;
}

export default getCardData;
